import { crudReducer } from "./dataHelper";

const initialState = () => ({
  users: []
});

export default crudReducer("user", initialState);
